// removed by extract-text-webpack-plugin
module.exports = {"root":"filtered-elements-count--root--13r0H-AV"};


//////////////////
// WEBPACK FOOTER
// ./components/filtered-elements-count/styles.css
// module id = ./components/filtered-elements-count/styles.css
// module chunks = 0